import clsx from 'clsx'

export const NewsFavicon = ({
  src,
  alt,
  faviconSize = 'md',
  className,
  onClick,
  ...props
}) => {
  const sizeClassMap = {
    xs: 'w-4 h-4',
    sm: 'w-5 h-5',
    md: 'w-6 h-6',
    lg: 'w-7 h-7',
    xl: 'w-10 h-10',
  }

  return (
    <img
      onClick={onClick}
      className={clsx(
        'rounded-full border border-border',
        sizeClassMap[faviconSize],
        className
      )}
      src={src}
      alt={alt}
      {...props}
    />
  )
}
